/* istanbul ignore file */
import { Icon } from '@distribusion/owl-frontend-ui'
import React, { ReactElement, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { LoginModal } from '@components/LoginModal'
import { useUserAuth } from '@hooks/userAuthProvider/provider'

interface PersonButtonProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

const PersonButton = ({ isOpen, setIsOpen }: PersonButtonProps): ReactElement => {
  const navigate = useNavigate()
  const { search } = useLocation()
  const { isAuthenticated, restoreSession } = useUserAuth()

  useEffect(() => {
    restoreSession()
  }, [restoreSession])

  if (!isAuthenticated) {
    return (
      <>
        <Icon name="passenger" size="large" onClick={() => setIsOpen(!isOpen)} />
        <LoginModal isOpen={isOpen} onClose={() => setIsOpen(!isOpen)} />
      </>
    )
  }

  return <Icon name="passenger" size="large" onClick={() => navigate(`/account/${search}`)} />
}

export default PersonButton
